import React from "react";
import PropTypes from "prop-types";
import { CNVideoPlayer } from "../../sharedComponents/VideoPlayer";
import { VideoType } from "./VideoType";
import YoutubeVideo from "../../sharedComponents/VideoPlayer/YoutubeVideo";

const VideoPlayer = ({
	style,
	className,
	cloudName,
	publicId,
	lang,
	posterUrl,
	videoId,
	type,
	videoTitle,
	autoPlay,
	setVideoPlayer,
}) => {
	switch (type) {
		case VideoType.YOUTUBE:
			return (
				<YoutubeVideo
					videoId={videoId}
					videoTitle={videoTitle}
					autoPlay={autoPlay}
					setVideoPlayer={setVideoPlayer}
				/>
			);

		case VideoType.CLOUDINARY:
			return (
				<CNVideoPlayer
					className={className}
					style={style}
					lang={lang}
					cloudName={cloudName}
					publicId={publicId}
					posterUrl={posterUrl}
					setPlayer={setVideoPlayer}
				/>
			);
		default:
			return "";
	}
};
VideoPlayer.propTypes = {
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	cloudName: PropTypes.string,
	posterUrl: PropTypes.string,
	publicId: PropTypes.string.isRequired,
	lang: PropTypes.oneOf(["en", "fr"]),
	videoId: PropTypes.string,
	type: PropTypes.oneOf(["Cloudinary", "YouTube", "Vimeo"]).isRequired,
	videoTitle: PropTypes.string,
	autoPlay: PropTypes.bool,
	setVideoPlayer: PropTypes.func,
};
VideoPlayer.defaultProps = {
	className: "",
	style: {},
	lang: "en",
	cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME,
	posterUrl: "",
	videoId: "",
	videoTitle: "",
	autoPlay: false,
	setVideoPlayer: null,
};

export default VideoPlayer;
export { VideoPlayer };
